export default __webpack_public_path__ + "static/4-263ab19facf224b0849d6a18778f0524.jpeg";